
import { Component, Vue, Watch } from "vue-property-decorator";
import Buscador from "@/components/Common/Web/Buscador.vue";
import { Notify } from "quasar";
import menuService from "@/services/menu.service";

interface dataButton {
  nombre?: string;
  tipo?: number;
  url?: string;
  nombre_web?: string;
  blank?: string;
  sub_menu?: Array<dataButton>;
}

@Component({
  components: {
    Buscador
  }
})
export default class SecondToolbarComponent extends Vue {
  private win = window;
  private left = false;
  private menu: Array<dataButton> = [];
  private buttonsNetworks: Array<dataButton> = [];

  private async beforeMount() {
    await this.getRuntimeConfig();
  }

  private async getRuntimeConfig() {
    this.menu = await menuService.getMenu();
  }
  private getPar(array: any, tipo: string) {
    const result: any[] = [];

    array.forEach((elemento: any, indice: number) => {
      if (tipo === "par" && indice % 2 === 0) {
        result.push(elemento);
      } else if (tipo === "impar" && indice % 2 !== 0) {
        result.push(elemento);
      }
    });

    return result;
  }
  private goToTramites() {
    this.$router.push("/portal-servicios");
  }

  irDonde(menu: dataButton) {
    if (menu.tipo == 1) {
      this.irPagina(menu.nombre_web);
    } else if (menu.tipo == 0) {
      this.toLink(menu.url, menu.blank);
    }
  }
  private routerGo(name: string) {
    if (name && name != "") {
      if (this.$router.currentRoute.name == name) {
        this.$router.go(0);
      } else {
        this.$router.push({ name: name }).catch(err => {
          console.log(err);
        });
      }
    }
  }

  private toLink(item: any, blank: any) {
    if (item && item != "") {
      if (blank == 1) {
        window.open(item, "_blank");
      } else {
        window.open(item, "_self");
      }
    } else {
      return;
    }
  }

  private irPagina(nombreWeb: any) {
    if (nombreWeb == "contacto") {
      this.routerGo("Contacto");
    } else if (nombreWeb == "concejo-municipal") {
      this.routerGo("Concejo");
    } else if (nombreWeb == "centros-de-atencion-municipal") {
      this.routerGo("Cam");
    } else if (nombreWeb == "oficinas-y-telefonos-municipales") {
      this.routerGo("Telefonos");
    } else if (nombreWeb == "organigrama-municipal") {
      this.routerGo("Organigrama");
    } else if (nombreWeb == "organigrama") {
      this.routerGo("OrganigramaDos");
    } else if (nombreWeb == "portal-servicios") {
      this.routerGo("PortalServicios");
    } else {
      if (nombreWeb && nombreWeb != "") {
        if (
          this.$router.currentRoute.name == "Pagina" &&
          this.$router.currentRoute.params.nombre &&
          this.$router.currentRoute.params.nombre == nombreWeb
        ) {
          this.$router.go(0);
        } else {
          if (this.$router.currentRoute.name == "Pagina") {
            if (
              this.$router.currentRoute.params.nombre &&
              this.$router.currentRoute.params.nombre != nombreWeb
            ) {
              this.$router
                .push({ name: "Pagina", params: { nombre: nombreWeb } })
                .catch(err => {
                  console.log(err);
                });
              this.$router.go(0);
            } else {
              this.$router
                .push({ name: "Pagina", params: { nombre: nombreWeb } })
                .catch(err => {
                  console.log(err);
                });
            }
          } else {
            this.$router
              .push({ name: "Pagina", params: { nombre: nombreWeb } })
              .catch(err => {
                console.log(err);
              });
          }
        }
      }
    }
  }
}
